"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const mobx_react_1 = require("mobx-react");
require("./index.scss");
const mobx_1 = require("mobx");
class HelpWorkRegistrationCard extends react_1.default.Component {
    constructor(props) {
        super(props);
        Object.defineProperty(this, "isHidden", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "hideFunc", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.isHidden = !this.isHidden;
            }
        });
        (0, mobx_1.makeObservable)(this, {
            isHidden: mobx_1.observable,
            hideFunc: mobx_1.action,
        });
    }
    render() {
        return (react_1.default.createElement("div", { className: `help-card-component ${this.isHidden ? 'hidden' : ''}` },
            react_1.default.createElement("div", { className: "head" },
                react_1.default.createElement("span", { className: "small bold" }, "Help content"),
                react_1.default.createElement("span", { className: "small bold hide", onClick: this.hideFunc }, this.isHidden ? 'Show' : 'Hide')),
            react_1.default.createElement("div", { className: "content" },
                " ",
                this.props.children)));
    }
}
exports.default = (0, mobx_react_1.observer)(HelpWorkRegistrationCard);
